import { createFileRoute } from "@tanstack/react-router";

import { BlogCategoryPage, categoryHead, guardPage } from "../components/blog/BlogCategoryPage";
import { pageCount, postsForCategory } from "../components/blog/BlogListing";

const BASE_PATH = "/blog/crm";

export const Route = createFileRoute("/blog/crm/page/$page")({
  loader: ({ params }) => ({
    page: guardPage(BASE_PATH, params.page, pageCount(postsForCategory("crm").length)),
  }),
  head: ({ loaderData }) => categoryHead("crm", loaderData?.page ?? 2),
  component: CategoryPageRoute,
});

function CategoryPageRoute() {
  const { page } = Route.useLoaderData();
  return <BlogCategoryPage categoryKey="crm" page={page} />;
}
